import { defaultApiInstance } from '@/compositions/api';

export function getSystemSettings() {
  return defaultApiInstance.get(`v1/systemSetting`);
}

export function setSystemSetting(data) {
  return defaultApiInstance.put(`v1/systemSetting`, JSON.stringify(data));
}
